module.exports = __webpack_public_path__ + "static/assets/e4f399430f25fa5d6ccb9d11c1698880.svg";